import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import ReactGA from "react-ga4";

import { BrowserRouter } from 'react-router-dom';

ReactGA.initialize("G-2H673HNQM8");
// ReactGA.send("pageview");

//console.log("API BASE URL:", ProcessingInstruction.env.REACT_APP_API_BASE);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  // <BrowserRouter>
 
    <App />
  
    // </BrowserRouter>
  // </React.StrictMode>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
